'use client';
import { useEffect, useRef, useState } from 'react';

import './styles/CookieBanner.scss';
import Link from 'next/link';



export default function CookieBanner () {
  const bannerRef = useRef<HTMLDivElement>(null);
  
  const handleScroll = () => {

    if ( window.scrollY > 40) {
      const cookieAgreement = document.cookie.split('; ').find(row => row.startsWith('cookieAgreement='));
      if (!cookieAgreement) {
        showCookieBanner();
      }
    }
  };

  useEffect(() => {
    if (!bannerRef.current) return;
    
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [bannerRef]);



  const showCookieBanner = () => {
    if (!bannerRef.current) return;

    bannerRef.current.classList.add('--visible');
  };

  const hideCookieBanner = () => {
    if (!bannerRef.current) return;

    bannerRef.current.classList.remove('--visible');
  }



  const handleCookieAccept = () => {
    document.cookie = "cookieAgreement=true; path=/";
    hideCookieBanner();
  };

  const handleCookieDecline = () => {
    document.cookie = "cookieAgreement=false; path=/";
    hideCookieBanner();
  };

  return (
    <div className="cookie-banner" ref={bannerRef}>
      <div className="cookie-banner__body">
        <p className="cookie-banner__text">
          This website stores cookies on your computer. Cookies help to provide a more personalized experience and relevant advertising for you, and web analytics for us. To learn more about the different cookies we're using, check out our <Link href="/privacy">Privacy</Link> and <Link href="/cookie-policy">Cookie Policy</Link>.
          We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again.
        </p>
        <div className="cookie-banner__controls">
          <button className="cookie-banner__controls--btn" onClick={handleCookieDecline}>Decline</button>
          <button className="cookie-banner__controls--btn --primary" onClick={handleCookieAccept}>Accept</button>
        </div>
      </div>
    </div>
  );
}
